import { Component, Host, h } from '@stencil/core';

@Component({
  tag: 'me-pipe-separator',
  styleUrl: 'me-pipe-separator.scss',
  shadow: false,
})
export class MePipeSeparator {

  render() {
    return (
      <Host class="me-pipe-separator">
        <template>
          <slot />{/* prevent duplicate pipes */}
        </template>
        <svg aria-hidden="true" viewBox="0 0 2 16" style={{ verticalAlign: '-0.2em', height: '1em' }}>
          <line x1="0" y1="5%" x2="0" y2="95%" style={{stroke: 'currentColor', 'stroke-width': '2'}} />
        </svg>
      </Host>
    );
  }

}
